import React, { useState, useEffect } from 'react';
import GridContainer from '@jumbo/components/GridContainer';
//import { useSelector } from 'react-redux';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import SinFicha from '../Components/SinFichaCreada';
import ConFicha from '../Components/ConFichaCreada';
import CondicionesDeUso from '../Components/CondicionesDeUso';
//import FormularioFichaTecnica from '../Components/FormularioFichaTecnica';
import { getFichaTecnica } from 'services/api';
import Spinner from '@jumbo/components/custom/Spinner';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';

//const breadcrumbs = [{ label: 'Fichas Técnicas', isActive: true }];

const FichasMain = () => {
  const user = JSON.parse(sessionStorage.getItem('user'))

  const [datosFicha, setDatosFicha] = useState(null)
  //const { user } = useSelector(({ claveUnica }) => claveUnica);
  /*   const [head, setHead] = useState(''); */
  const [showCondiciones, setShowCondiciones] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [showSinFicha, setShowSinFicha] = useState(false);
  const [showConFicha, setShowConFicha] = useState(false);

  const [loading, setLoading] = useState(true)
  const [firstLoad, setFirstLoad] = useState(true)

  const closeModalCondiciones = () => {
    setShowCondiciones(false);
  };

  const openModalCondiciones = () => {
    setShowCondiciones(true);
  };

  useEffect(()=>{

    if(datosFicha && !firstLoad){
      setShowForm(true)
    }else{
      setShowConFicha(true)
      setFirstLoad(true)
    }
//eslint-disable-next-line react-hooks/exhaustive-deps
  },[datosFicha])

/*   useEffect(() => {
    if (user) {
     
      try {
 
      } catch (error) {
     
      }
  
    } else {
   
    }
  }, [user]); */

  useEffect(() => {
    if(user){
      
      getFichaTecnica(user.organization.name)
        .then(res => {
          setDatosFicha(res.data)
       /*    console.log('datos ficha',res.data) */
          sessionStorage.setItem('idFicha',res.data.id)
          sessionStorage.setItem('region',res.data.identidad.region_desc.id)
          let aux = {
            i:res.data.identidad.id_prestador,
            r:res.data.identidad.rut_prestador
          }

          sessionStorage.setItem('prft',JSON.stringify(aux))
        })
        .catch(e => {
          if (e.response && e.response.status === 400) {
            const errorDetail = e.response.data.detail;
  
  
            if (errorDetail === "No se encontro prestador") {
              setShowSinFicha(true)
              setShowConFicha(false)
            } else {
  
              console.log(e);
              toast.error('ocurrió un error al cagar la ficha técnica')
            }
          } else {
            console.log(e);
            toast.error('ocurrió un error al cagar la ficha técnica')
          }
        })
        .finally(() => {
          setLoading(false)
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getView = () => {
    if (showSinFicha) {
      return <SinFicha openCondiciones={openModalCondiciones} />;
    }

/*     if (showForm) {
      return <FormularioFichaTecnica setShowForm={setShowForm} setShowConFicha={setShowConFicha} datosFicha={datosFicha} />;
    } */

    if (showConFicha) {
      return <ConFicha setShowForm={setShowForm} setShowConFicha={setShowConFicha} datosFicha={datosFicha} />;
    }
  };

  return (

    <>
      {loading ? <Spinner show={loading} /> :
        <PageContainer heading={''} >
          <CustomToast />
          <CondicionesDeUso
            openDialog={showCondiciones}
            close={closeModalCondiciones}
            setShowForm={setShowForm}
            setShowSinFicha={setShowSinFicha}
            user={user}
            setDatosFicha = {setDatosFicha}
          />
          <GridContainer>{getView()}</GridContainer>
        </PageContainer>
      }
      {showForm ? null : null}

    </>
  );
};

export default FichasMain;
